export default __webpack_public_path__ + "static/media/ContestDate.11497ab6.svg";